import React from 'react';
import './StarRatingInput.css';

// Issue #39: Clickable star rating input for creating course reviews
// Allows users to select 1-5 stars
function StarRatingInput({ rating, onRatingChange }) {
  const handleStarClick = (selectedRating) => {
    onRatingChange(selectedRating);
  };

  return (
    <div className="star-rating-input">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          className={`star-button ${star <= rating ? 'filled' : 'empty'}`}
          onClick={() => handleStarClick(star)}
          aria-label={`Rate ${star} star${star > 1 ? 's' : ''}`}
        >
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15 2.5L18.09 11.26L27.45 12.36L21.23 18.32L22.68 27.64L15 23.09L7.32 27.64L8.77 18.32L2.55 12.36L11.91 11.26L15 2.5Z"
              fill={star <= rating ? '#F6B707' : 'none'}
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      ))}
    </div>
  );
}

export default StarRatingInput;
